class OTFControlSidebar {
    constructor() {
        $('#customize-theme-controls .osf-switch-sidebar').on('change', (event) => {
            let $button = $(event.currentTarget).next().find('button');
            $button.attr('data-id', 'sidebar-widgets-' + event.currentTarget.value);
        });
    }
}

